export default __webpack_public_path__ + "static/media/247.9f0dd1f1.jpg";